import { Typography } from '@mui/material'
import React from 'react'
import { useAppSelector } from 'store/hooks'
import { StoreStatus } from 'common/utils/types'

const Message: React.FC = () => {
  const { message, status } = useAppSelector((state) => state.auth)

  return (
    <Typography
      className={`w-full ${message?.length ? '' : 'hidden'}`}
      title={status}
      sx={{
        color: StoreStatus.Failed ? '#A9404A' : '#3DB19E',
      }}
    >
      {message}
    </Typography>
  )
}

export default Message
